import { Grid } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import { getType } from 'typesafe-actions';
import CardContainer from '../../../../common/components/cards/cardContainer';
import { rootSelector } from '../../../../common/selectors/selectors';
import {
  deleteImageAction,
  groupForgotPasswordActions,
  groupVisitActions,
} from '../../groupVisits.actions';
import {
  GroupVisitDto,
  groupVisitInit,
  ImageDto,
  imageInit,
} from '../../groupVisits.dtos';
import GroupVisitForm from './groupVisitForm';
import Viewer from '../images/viewer';
import ImageList from '../images/imageList';
import DeleteDialog from '../../../../common/components/dialog/DeleteDialog';

interface DetailParams {
  id: string;
}

const GroupInfo: React.FC<RouteComponentProps<DetailParams>> = ({ match }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const systemGroupVisit = rootSelector(
    (state) => state.groupVisits.groupVisit
  );

  const [groupVisit, setGroupVisit] = useState<GroupVisitDto>(groupVisitInit);

  const [selectedImage, setSelectedImage] = useState('');
  const [selectedType, setSelectedType] = useState('');
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [selectedImageDelete, setSelectedImageDelete] =
    useState<ImageDto>(imageInit);

  useEffect(() => {
    if (match.params.id !== undefined) {
      dispatch({
        type: getType(groupVisitActions.request),
        payload: match.params.id,
      });
    }
  }, [match.params.id, dispatch]);

  useEffect(() => {
    if (match.params.id !== undefined) {
      setGroupVisit(systemGroupVisit);
    } else {
      setGroupVisit(groupVisitInit);
    }
  }, [systemGroupVisit, dispatch, match.params.id]);

  const onClose = () => history.push('/group-visits');

  const onSelectImage = (image: string, type: string) => {
    setSelectedImage(image);
    setSelectedType(type);
  };

  const handleDialogDelete = async (image: ImageDto) => {
    await deleteImageAction(image);

    dispatch({
      type: getType(groupVisitActions.request),
      payload: match.params.id,
    });

    setDeleteDialogOpen(false);
  };

  const handleDeleteDialogClose = () => {
    setDeleteDialogOpen(false);
  };

  const openDeleteDialog = (image: ImageDto) => {
    setSelectedImageDelete(image);
    setDeleteDialogOpen(true);
  };

  const onSendReset = () => {
    dispatch({
      type: getType(groupForgotPasswordActions.request),
      payload: match.params.id,
    });
  };

  return (
    <>
      {deleteDialogOpen ? (
        <DeleteDialog
          open={deleteDialogOpen}
          onDelete={handleDialogDelete}
          onClose={handleDeleteDialogClose}
          value={selectedImageDelete}
        />
      ) : null}
      <CardContainer
        title='Group Details'
        cards={
          <Grid container item spacing={2}>
            <Grid item xs={12} sm={4}>
              <GroupVisitForm
                groupVisit={groupVisit}
                onClose={onClose}
                onSendReset={onSendReset}
              />
            </Grid>
            {selectedImage != '' ? (
              <Grid item xs={12} sm={4}>
                <Viewer image={selectedImage} type={selectedType} />
              </Grid>
            ) : null}
            {groupVisit.images != null && groupVisit.images.length > 0 ? (
              <ImageList
                images={groupVisit.images}
                onClick={onSelectImage}
                onSelect={openDeleteDialog}
              />
            ) : null}
          </Grid>
        }
      />
    </>
  );
};

export default GroupInfo;
